export default __webpack_public_path__ + "static/media/ColdWorkImg.5978aa16.jpg";